<template>
  <div class="home">
    <page-content>
      <div class="row">
        <div class="offset-md-3 col-md-6 px-5">
          <ntm-block>
            <div class="p-2 position-relative">
              <le-loading v-if="loading"></le-loading>
              <p class="font-size-md">{{$t('enter-code.welcome')}}</p>

              <form @submit.prevent="handleSubmit">
                <div class="d-flex justify-content-center mb-3">
                  <PinInput
                    autofocus
                    ref="pinInput"
                    @complete="handleSubmit"
                    :length="6"
                    v-model="code"
                    placeholder="X"
                  />
                </div>

                <span v-if="errorText === 'game-code-not-valid'" class="help-block text-danger d-block mb-2">{{ $t('game-code.notValid') }}</span>
              </form>
            </div>
          </ntm-block>
        </div>
      </div>

    </page-content>
  </div>
</template>
<script>
import GameService from '@/services/game.service'
import ApiService from '@/services/api.service'
import { redirectToGameRouteByStatus } from '@/use/useRedirectGame'
import PinInput from '@/components/le/PinInput.vue'
import { routeAfterGame } from '@/use/useStartPage'
import LeLoading from '@/components/le/LeLoading.vue'
export default {
  components: {
    LeLoading,
    PinInput
  },
  created () {
    // Only the external scorekeeper enters a game code. Admins, owners, managers (internal scorekeepers: they have the
    // list of games) and media managers are sent to their own page
    if (!this.$store.getters.isExternalScorekeeper) {
      this.$router.replace({ ...routeAfterGame(this.$store), params: { clientId: this.$route.params.clientId } })
    }
  },
  data () {
    return {
      loading: false,
      errorText: null,
      code: '',
      form: {},
      fields: [
        {
          key: 'code',
          type: 'input',
          required: true
        }
      ]
    }
  },
  methods: {
    handleSubmit () {
      this.loading = true
      ApiService.setGameCode(this.code)
      GameService.status().then((res) => {
        this.$router.push(redirectToGameRouteByStatus(this.$route.params.clientId, this.code, res.data))
      }).catch((error) => {
        this.$refs.pinInput.reset()
        this.errorText = error.response?.data
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
